import {ThemeType} from '@ant-design/icons-angular';
import {InjectionToken} from '@angular/core';
import { WFSState } from '@app/components/cleanui/styles/config.defaults';

export interface IBadge {
	setStatus(status: Status): void;
}

export interface Status {
	iconTheme?: ThemeType;
	iconName: string;
	color: string;
	colorShouldBeBackground: boolean;
	label: string;
	disabled: boolean;
}

export function toStatus(state: WFSState):Status{
	return {
		color: state.color,
		colorShouldBeBackground: state.colorShouldBeBackground,
		iconName: state.symbol || null,
		label: state.label || null,
		disabled: state.disabled ?? false,
	};
}

export const BADGE = new InjectionToken<IBadge>('IBadge');
